import useSWRMutation from "swr/mutation";
import { useDeleter, SWRApiError, useUpdater, UpdaterParams } from "./swr";
import {
  StructureUpdatePayload,
  StructureUpdatePreview,
  StructureUpdatePreviewRaw,
} from "@/types/structure";
import { mapRawToStructureUpdatePreview } from "@/mappers/structure";

export const useDeleteStructure = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string; mask_id?: string }>(
    "/structures",
    deleter,
  );
};

export const usePreviewStructureUpdate = () => {
  const updater = useUpdater();

  return useSWRMutation<
    StructureUpdatePreview,
    SWRApiError,
    UpdaterParams,
    StructureUpdatePayload & { id: string }
  >({ url: "/structures", action: "preview" }, async (params, { arg }) =>
    mapRawToStructureUpdatePreview(
      await updater<StructureUpdatePayload & { id: string }, StructureUpdatePreviewRaw>(params, {
        arg,
      }),
    ),
  );
};

export const useUpdateStructure = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, StructureUpdatePayload & { id: string }>(
    { url: "/structures" },
    updater,
  );
};
